import script from "./ProgramArrItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramArrItem.vue?vue&type=script&setup=true&lang=js"

import "./ProgramArrItem.vue?vue&type=style&index=0&id=271a9a18&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-271a9a18"]])

export default __exports__